// An address that matches no screen. The default of the router is English; this one is German and leads back.

import { Link } from "react-aria-components";
import { cx } from "../../lib/cx";
import { useT } from "../../lib/i18n";
import styles from "./shell.module.css";
import { usePageTitle } from "./usePageTitle";

export function NotFound() {
  const t = useT();
  usePageTitle(t("notfound.title"));
  return (
    <>
      <div className="sf-pagehead">
        <h1 className="sf-pagehead__title">{t("notfound.title")}</h1>
      </div>
      <div className={cx("sf-block", styles.readable)}>
        <div className="sf-empty">
          <p className="sf-empty__text">{t("notfound.text")}</p>
          <Link className="sf-plate sf-plate--primary" href="/">
            {t("notfound.action")}
          </Link>
        </div>
      </div>
    </>
  );
}
